export default __webpack_public_path__ + "static/media/review-woman-2.4eb31679.png";